import * as types from '@/store/mutation-types'
export const CODE_TIMER = {
  data () {
    return {
      tel: '',
      code: '',
      timer: null,
      timeCount: 60
    }
  },
  onLoad () {
    Object.assign(this, this.$options.data())
    this.initTimer()
  },
  onUnload () {
    this.clearTimer()
    this.$refs.identify.isShow = false
  },
  methods: {
    identified () {
      this.clearTimer()
      this.timeCount = 60
      this.$store.commit(types.SET_CODE_TIMER, {
        mobile: this.tel,
        time: new Date().getTime()
      })
      this.timer = setInterval(() => {
        this.timeCount--
        if (this.timeCount <= 0) {
          this.clearTimer()
        }
      }, 1000)
    },

    initTimer () {
      this.clearTimer()
      let data = this.$store.state.codeTimer
      if (data) {
        let nowTime = new Date().getTime()
        if (nowTime - data.time * 1 < 60 * 1000) {
          this.tel = data.mobile
          this.timeCount = parseInt((data.time * 1 + 60000 - nowTime) / 1000)
          this.timer = setInterval(() => {
            this.timeCount--
            if (this.timeCount <= 0) {
              this.clearTimer()
            }
          }, 1000)
        }
      }
    },
    clearTimer () {
      if (this.timer) {
        clearInterval(this.timer)
        this.timer = null
      }
      this.timeCount = 0
    },
    getCode (e, v) {
      let tel = v || this.tel
      if (!tel || !this.$validate.isMobile(tel)) {
        this.$toast('请输入正确的手机号');
        return
      }
      this.$refs['identify'].isShow = true
    }
  }
}
